export default function updateStickyHeaderVisibility(context, payload, done) {
  context.dispatch('UPDATE_STICKY_HEADER_VISIBILITY', {
    isStickyHeaderVisible: payload.isSticky,
  });
  if (done) {
    done();
  }
}
